import $ from "jquery"
import "slick-carousel"

const topHeader = () => {
  const init = () => {
    slick()
  }

  const slick = () => {
    const el = {
      slider: ".js-TopHeader__Slider",
    }

    if ($(el.slider).length === 0) return

    $(el.slider).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      dots: false,
      arrows: false,
      draggable: false,
      pauseOnFocus: false,
      pauseOnHover: false,
    })
  }

  init()
}

const topHeaderPopup = () => {
  $("#mi-CareerPopup").hide()
  $("#mi-CareerPopupForm").hide()
  $("#mi-CareerPopupFormConfirmation").hide()
  $("#mi-CareerPopupFormConfirmationError").hide()

  //   Popup Career and Fetch Data Career Title
  $(".mi-TopHeader__Slider__Item").click(function () {
    const jobValue = $(this).find(".mi-CareerSliderTitle").text()
    var popupCareer = $("#mi-CareerPopup")

    popupCareer.css("display", "flex")
    if (popupCareer.css("display", "flex")) {
      $("html").css("overflow", "hidden")
    }
    $("#mi-CareerPopupForm .mi-CareerPopupForm--Section_Job").html(jobValue)
  })

  // Popup close if click outside the form area
  $("#mi-CareerPopup").click(function () {
    $("#mi-CareerPopup").hide()
    $("html").css("overflow", "auto")
  })

  $(".mi-CareerPopup--Section").click(function (e) {
    e.stopPropagation()
  })

  //   close button career popup
  $(".mi-CloseBtn").click(function () {
    $("#mi-CareerPopup").fadeToggle("fast")
    $("html").css("overflow", "auto")
  })

  //   button continue career popup
  $(".mi-CareerPopup--Button").click(function () {
    $("#mi-CareerPopup").hide()
    $("#mi-CareerPopupForm").fadeToggle("slow")
    $("#mi-CareerPopupForm").css("display", "flex")
  })

  //    POPUP FORM
  //   close button career form popup
  $(".mi-CareerPopupFormCloseBtn").click(function () {
    $("#mi-CareerPopupForm").fadeToggle("fast")
    $("html").css("overflow-y", "auto")
  })

  // Popup close if click outside the form area
  $("#mi-CareerPopupForm").click(function () {
    $("#mi-CareerPopupForm").hide()
    $("html").css("overflow", "auto")
  })

  $(".mi-CareerPopupForm--Section").click(function (e) {
    e.stopPropagation()
  })
}

const newTab = () => {
  const link = $(".css-TopHeader__Slider__Item")

  if (link.length > 0) {
    if (window.innerWidth >= 768) {
      link.attr("target", "_blank")
    } else {
      link.removeAttr("target")
    }
  }
}

// Contact Page Layout Form
const changeLayoutMobile = () => {
  const formContact = document.querySelector("#mi-TabCareerForm")

  if (formContact) {
    var ScreenWidth = window.innerWidth
    if (ScreenWidth <= 767) {
      const tabs = document.querySelectorAll(
        "#mi-TabCareerForm .elementor-tabs-content-wrapper div.elementor-tab-mobile-title",
      )
      tabs[0].after(tabs[1])
    }
  }
}

const HelperPluginWeird = () => {
  $(".premium-vscroll-temp > style").remove()
}

const headerHideOffset = () => {
  var getPageYOffset =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0

  var prevScrollpos = getPageYOffset

  $(window).on("load", function () {
    document.getElementById("mi-HeaderTopMain").style.top = "0px"
    document.getElementById("mi-MainHeader").style.top = "34px"
    document.getElementById("mi-MainHeaderMobile").style.top = "34px"

    if (window.screen.width > 600) {
      document.getElementById("mi-ButtonHeader").style.display = "block"
      document.getElementById("mi-ButtonHeader").style.top = "56px"
    }

    window.addEventListener("scroll", function () {
      var currentScrollPos = window.pageYOffset
      var navmenu = document.getElementById("mi-SideNavbar")

      if (navmenu) {
        return
      }

      if (prevScrollpos > currentScrollPos || currentScrollPos <= 30) {
        document.getElementById("mi-HeaderTopMain").style.top = "0px"
        document.getElementById("mi-MainHeader").style.top = "34px"
        document.getElementById("mi-ButtonHeader").style.top = "56px"
        document.getElementById("mi-MainHeaderMobile").style.top = "34px"
      } else {
        document.getElementById("mi-HeaderTopMain").style.top = "-80px"
        document.getElementById("mi-MainHeader").style.top = "-80px"
        document.getElementById("mi-ButtonHeader").style.top = "-80px"
        document.getElementById("mi-MainHeaderMobile").style.top = "-80px"
      }

      prevScrollpos = currentScrollPos
    })
  })
}

// const reloadToTop = () => {
//   $(document).ready(function () {
//     $("html, body").animate({ scrollTop: 0 })
//   })
// }

topHeader()
// topHeaderPopup()
newTab()
changeLayoutMobile()
HelperPluginWeird()
headerHideOffset()
// reloadToTop()
